/**
 * @module services/ai
 * @description Servicio para comunicación con el módulo de IA clínica
 */
import api from "./api";

const aiService = {
  /**
   * Obtiene la configuración de IA de la organización
   * @returns {Promise<Object>} Configuración actual
   */
  getConfig() {
    return api.get("/ai/config");
  },

  /**
   * Guarda la configuración de IA de la organización
   * @param {Object} data - Datos de configuración
   * @param {boolean} data.enabled
   * @param {string} data.provider - 'claude' | 'openai' | 'custom'
   * @param {string} data.apiKey
   * @param {string} data.model
   * @param {string} [data.endpoint]
   * @param {string} [data.systemPrompt]
   * @returns {Promise<Object>} Configuración guardada
   */
  saveConfig(data) {
    return api.put("/ai/config", data);
  },

  /**
   * Analiza la transcripción de una consulta con IA
   * @param {string} transcription - Texto transcripto de la consulta
   * @returns {Promise<Object>} Sugerencias estructuradas de la IA
   */
  analyzeConsultation(transcription) {
    return api
      .post("/ai/analyze-consultation", { transcription })
      .then((response) => response.data);
  },

  /**
   * Genera un resumen clínico del paciente usando IA
   * @param {string} patientId - ID del paciente
   * @param {string} doctorId - ID del médico que va a atender
   * @returns {Promise<Object>} Resumen generado
   */
  patientSummary(patientId, doctorId) {
    return api
      .post("/ai/patient-summary", { patientId, doctorId })
      .then((response) => response.data);
  },
};

export default aiService;
